const STORAGE_KEY = 'roofora.anonymousToolId'

function generateId(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

/**
 * Rein clientseitige, first-party Kennung (localStorage, kein Cookie, kein Cross-Site-Tracking,
 * kein Name/keine E-Mail) für PV-Rechner/PV-Kostenrechner-Nutzung (GitLab-Issue #190). Erlaubt dem
 * Backend, eine spätere Auftrags-Veröffentlichung mit vorheriger Rechner-Nutzung zu verknüpfen (siehe
 * CalculatorUsageService.linkConversion) - für die Admin-Konsole, nicht für Marketing/Analytics.
 * Wie httpClient.ts' readStoredAuth: try/catch statt harter Abhängigkeit von localStorage, damit
 * ein blockierter/privater Modus den Rechner selbst nicht kaputt macht.
 */
export function getAnonymousToolId(): string | undefined {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing) return existing
    const created = generateId()
    localStorage.setItem(STORAGE_KEY, created)
    return created
  } catch {
    return undefined
  }
}
